/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Process instance activity type
 */
export enum ProcessInstanceActivityType {
  SERVICE_TASK = 'SERVICE_TASK',
  SEQUENCE_FLOW = 'SEQUENCE_FLOW',
  USER_TASK = 'USER_TASK',
  START_EVENT = 'START_EVENT',
  END_EVENT = 'END_EVENT',
  CALL_ACTIVITY = 'CALL_ACTIVITY',
  ACTIVITY = 'ACTIVITY',
  GATEWAY = 'GATEWAY',
  EXCLUSIVE_GATEWAY = 'EXCLUSIVE_GATEWAY'
}
